import { getAddToCartButtonState } from "./getAddToCartButtonState";
import { getDateFromStatusMessage } from "./getDateFromStatusMessage";
import { isFuturePreorder } from "./isLongHorizonPreorder";

/**
 * Returns the expected release date (yyyy-MM-dd) when the item is a preorder,
 * using the same rules as the add-to-cart button. Returns null otherwise.
 */
export function getPreorderReleaseDate({
  canBeSold,
  statusMessage,
  publicationDate,
}: {
  canBeSold: boolean;
  statusMessage?: string | null;
  publicationDate?: string | null;
}): string | null {
  const { label } = getAddToCartButtonState(
    canBeSold,
    statusMessage ?? undefined,
    publicationDate ?? undefined,
  );
  if (label !== "Forhåndsbestill") return null;

  const date = isFuturePreorder({ publicationDate })
    ? publicationDate
    : getDateFromStatusMessage(statusMessage ?? undefined);
  return date?.split("T")[0] ?? null;
}
